import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'calendar-icon',
  templateUrl: './calendar-icon.component.html',
  styles: [':host { line-height: 0; }'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class CalendarIconComponent {}
